import { Chip, ChipProps } from '@mui/material';
import { getPickingStationStatusColors } from '@peritasai/ui-shared';

interface PickingStationStatusChipProps extends Omit<ChipProps, 'label'> {
  status: 'Available' | 'Busy' | 'Offline';
  label?: string;
}

export function PickingStationStatusChip({
  status,
  label,
  ...props
}: PickingStationStatusChipProps) {
  const statusColors = getPickingStationStatusColors(status);

  return (
    <Chip
      label={label || status}
      style={{
        backgroundColor: statusColors.background,
        color: statusColors.text,
        border: 'none',
        fontWeight: 500,
      }}
      {...props}
    />
  );
}
